module.exports = __webpack_public_path__ + "media/images/fancy-check-4aaa611db133a4b5ec7bad83a7b2b875.svg";